import { Box, Breadcrumbs, Link, Paper, Typography } from '@mui/material';
import { CustomButton } from '../../../../../components/CustomButton';
import React, { useEffect, useState } from 'react';
import EnhancedTable from '../../../../../components/EnhancedTable';
import { useDispatch, useSelector } from 'react-redux';
import { MAILING_HEAD_CELLS } from '../../../constants/headCell';
import { MailingTableBody } from '../../../components/MailingTableBody';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { ROUTES } from '../../../../../constants/routes';
import {
  createMailingForBonusCard, deleteMailingForBonusCard,
  getBonusCardMailingTemplates, getGroupedTemplates,
  getMailingTriggers, updateMailingForBonusCard
} from '../../../../../store/mailing/actions';
import { MAILING_TYPE, PERMISSIONS } from '../../../../../constants/variables';
import { visibleBySectionPermission } from '../../../../../utils/visibleBySectionPermission';
import { setUsersPermissions } from '../../../../../utils/setUsersPermissions';

export const AddEventSecondStep = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { instanceId } = useSelector((state) => state.bonuses);
  const { bonusCardTemplates, groupedTemplates, triggers, fetching, error } = useSelector((state) => state.mailing);
  const { userPermissions, currentUsersPermissions } = useSelector((state) => state.userPermissions);
  const permissions = setUsersPermissions(userPermissions, currentUsersPermissions?.permissions);
  const [mailingList, setMailingList] = useState([]);
  const [prefilledRow, setPrefilledRow] = useState({});
  const [filter, setFilter] = useState({
    orderBy: 'mailing_type',  // mailing_type | mailing_trigger_id | mailing_template_id
    orderType: 'desc',
    page: 0,
    size: 10,
  });

  const redirectToBonuses = () => history.push(ROUTES.BONUSES);

  const addRow = ({ triggerId, templateId, mailingId }, isFinalAdd = false) => {
    setMailingList([...mailingList, {triggerId, templateId, mailingId}]);
    setPrefilledRow({});

    const payload = {
      mailing_template_id: templateId,
      mailing_trigger_id: triggerId,
    };
    dispatch(createMailingForBonusCard(instanceId, payload, false, isFinalAdd ? redirectToBonuses : null));
  };

  const prefillRow = (row) => {
    setPrefilledRow(row);
  };

  const submitForm = (checkPrefilled = false) => {
    checkPrefilled && Object.keys(prefilledRow).length ?
      addRow(prefilledRow, true) :
      redirectToBonuses();
  };

  const updateRow = ({mailingId, templateId, triggerId}) => {
    setMailingList([...mailingList, {mailingId, templateId, triggerId}]);

    const payload = {
      mailing_template_id: templateId,
      mailing_trigger_id: triggerId,
    };

    let changedMailing = bonusCardTemplates.find((template) => template.id === mailingId);
    const changedMailingType = mailingTemplatesOptions.find((option) => option.value === templateId).mailingType;
    const changedMailingTemplate = groupedTemplates[changedMailingType].find((item) => item.id === templateId);
    const changedMailingTrigger = triggers.find((trigger) => trigger.id === triggerId);
    changedMailing = {
      ...changedMailing,
      mailing_template: changedMailingTemplate,
      mailing_trigger: { id: changedMailingTrigger.id, name: changedMailingTrigger.name },
    };

    dispatch(updateMailingForBonusCard(instanceId, mailingId, payload, changedMailing));
  };

  const deleteRow = (mailingId) => {
    setMailingList([...mailingList.filter((list) => list.mailingId !== mailingId)]);
    dispatch(deleteMailingForBonusCard(instanceId, mailingId));
  };

  useEffect(() => {
    dispatch(getGroupedTemplates());
    dispatch(getMailingTriggers());
  }, // eslint-disable-next-line
    []);

  useEffect(() => {
    if (instanceId) {
      dispatch(getBonusCardMailingTemplates(
        instanceId,
        {
          page: filter.page + 1,
          order_type: filter.orderType,
          order_by: filter.orderBy,
          size: filter.size,
        },
      ));
    } // eslint-disable-next-line
  }, [
    filter.orderType,
    filter.orderBy,
    filter.size,
    filter.page,
  ]);

  const mailingTemplatesOptions = [];
  Object.keys(groupedTemplates || {}).forEach((mailingType) => {
    groupedTemplates[mailingType]?.forEach((template) => {
      mailingTemplatesOptions.push({
        label: template.name, value: template.id, mailingType, text: template.text,
      })
    });
  });
  const mailingTriggersOptions = triggers?.map((trigger) => ({ label: trigger.name, value: trigger.id })) || [];
  const mailingTypes = Object.keys(MAILING_TYPE).map((key) => ({ label: MAILING_TYPE[key], value: key }));

  const isPageVisible = visibleBySectionPermission(permissions, [PERMISSIONS.BONUS.ListBonusCards.value, PERMISSIONS.BONUS.CreateBonusCards.value], 'or');
  const isCreateEventPageAccessible = visibleBySectionPermission(permissions, [PERMISSIONS.BONUS.UpdateBonusCards.value, PERMISSIONS.BONUS.CreateBonusCards.value], 'or');

  if (!isPageVisible || !isCreateEventPageAccessible) {
    return <></>;
  }

  return (
    <Box id="add-event-step-2">
      <Typography mb="24px" variant="h1" sx={{ color: 'text.primary' }} component="h1" data-testid="TitleMain">
        Добавить событие
      </Typography>
      <Breadcrumbs>
        <Link component={RouterLink} underline="hover" color="inherit" to={ROUTES.BONUSES}>
          Бонусы
        </Link>
        <Box>Добавить событие</Box>
      </Breadcrumbs>

      <Paper sx={{ padding: '24px', marginTop: '24px' }}>
        <Typography mb="24px" variant="h1" sx={{ color: 'text.primary', fontSize: '20px', lineHeight: '24px' }} component="h1" data-testid="Subtitle">
          Добавление СМС/Email рассылок
        </Typography>

        <form data-testid="Form">
          <EnhancedTable
            rows={bonusCardTemplates || []}
            headCells={MAILING_HEAD_CELLS}
            total={bonusCardTemplates?.length || 0}
            fetching={fetching}
            heightRow={109}
            filter={filter}
            setFilter={setFilter}
            rowsPerPage={[5, 10, 20]}
            showPagination={false}
          >
            <MailingTableBody
              data={bonusCardTemplates}
              templates={mailingTemplatesOptions}
              triggers={mailingTriggersOptions}
              mailingTypes={mailingTypes}
              updateRow={updateRow}
              addRow={addRow}
              deleteRow={deleteRow}
              prefillRow={prefillRow}
              permissions={permissions}
            />
          </EnhancedTable>
          {
            error && (
              <Box color="error.main" fontSize="1rem" textAlign="center" data-testid="ErrorBlock">
                {error}
              </Box>
            )
          }

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              marginTop: '24px'
            }}>
            <Box>
              <CustomButton
                type="submit"
                size="large"
                color="secondary"
                variant="contained"
                onClick={submitForm}
              >
                Пропустить
              </CustomButton>

              <CustomButton
                sx={{ marginLeft: '16px', width: '146px' }}
                size="large"
                variant="contained"
                disabled={!mailingList.length}
                onClick={() => submitForm(true)}
              >
                Сохранить
              </CustomButton>
            </Box>
          </Box>
        </form>
      </Paper>
    </Box>
  );
}
